import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {RoundCheckbox} from './RoundCheckbox';
import {Button} from 'react-bootstrap';
import VSImage from './VSImage';
import ImageInfoTooltip, {createTooltipId} from '../containers/ImageInfoTooltip';

export default class GalleryThumbnail extends Component {
    static propTypes = {
        srcPrefix: PropTypes.string,
        cell: PropTypes.shape({
            width: PropTypes.number,
            imgWidth: PropTypes.number,
            height: PropTypes.number,
            marginLeft: PropTypes.number,
            margin: PropTypes.number,
        }),
        image: PropTypes.shape({
            id: PropTypes.number,
            uploadId: PropTypes.number,
            previewSrc: PropTypes.string,
            status: PropTypes.string,
            error: PropTypes.string,
            uploadPct: PropTypes.number,
        }).isRequired,
        onOpen: PropTypes.func,
        onEdit: PropTypes.func,
        onToggleSelectImage: PropTypes.func,
        lastVisited: PropTypes.bool,
        selected: PropTypes.bool,
        selectionMode: PropTypes.bool,
        hideEditButtons: PropTypes.bool,
    };

    handleOpen = () => {
        if (this.props.onOpen) {
            this.props.onOpen(this.props.image);
        }
    };

    handleSelect = (e) => {
        e.stopPropagation();
        const {onToggleSelectImage, image: {id, userId}} = this.props;
        onToggleSelectImage(id, userId, e.nativeEvent.shiftKey);
    };

    handleClick = (e) => {
        if (this.props.selectionMode) {
            this.handleSelect(e);
        } else {
            this.handleOpen(e);
        }
    };

    handleEdit = (e) => {
        e.stopPropagation();
        const {onEdit, image} = this.props;
        onEdit(image);
    };

    render() {
        const {image, srcPrefix, lastVisited, selected, selectionMode, cell, hideEditButtons} = this.props;
        const {width, height, margin} = cell;

        const previewSrc = (srcPrefix || '') + image.previewSrc;

        const thmStyle = {width, height, float: 'left', marginRight: margin, overflow: 'hidden', position: 'relative'};
        return (
            <div className={classNames('thm', {lastVisited, selected, selectionMode})} style={thmStyle}>
                <VSImage src={previewSrc} crossOrigin="use-credentials" aspectRatio={image.height / image.width} style={{width: '100%', height: '100%'}} onClick={this.handleClick}/>
                <div className="thumbnail-top" onClick={this.handleClick} title={image.fileName}/>
                {selectionMode && <div className="thumbnail-bottom" onClick={this.handleClick} title={image.fileName}/>}
                <div className="selector">
                    <RoundCheckbox onChange={this.handleSelect} checked={selected}/>
                </div>
                {!hideEditButtons &&
                <div className="info" data-tip data-for={createTooltipId(image.id)}>
                    <Button bsStyle="link" ><i className="fa fa-info-circle"/></Button>
                </div>
                }
                {selectionMode &&
                <div className="opener">
                    <Button bsStyle="link" onClick={this.handleOpen}><i className="fa fa-search-plus"/></Button>
                </div>
                }
                {!hideEditButtons &&
                    <ImageInfoTooltip id={image.id} event="click" eventOff="mouseleave"/>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/GalleryThumbnail.js